module.exports = __webpack_public_path__ + "static/media/icon-check-green-001.4444c33c.svg";